import { render } from "./HistoryManage.vue?vue&type=template&id=72f2c116&scoped=true"
import script from "./HistoryManage.vue?vue&type=script&lang=js"
export * from "./HistoryManage.vue?vue&type=script&lang=js"

import "./HistoryManage.vue?vue&type=style&index=0&id=72f2c116&lang=scss"
import "./HistoryManage.vue?vue&type=style&index=1&id=72f2c116&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f2c116"]])

export default __exports__